import {Injectable} from '@angular/core';
import {Subject} from "rxjs/Subject";
import {AccessToken} from "./access-token";
import {Profile} from "./profile";
import {Http, RequestOptions, Headers} from "@angular/http";



export class OauthService {

  constructor(private http : Http) {

    window.addEventListener("message", (event) => {
      let anyEvent: any = event;
      var origin = event.origin || anyEvent.originalEvent.origin;

      //window.alert('App received access token - ' + event.data);

      if (!!origin && origin.indexOf(this._base) != -1) {


        if (event.data && event.data.length > 0) {
          let token : AccessToken = new AccessToken();
          token.type = event.data.split(" ")[0];
          token.value = event.data.split(" ")[1];
          this.accessToken = token;
          this.onLoggedIn.next(token);
          this.loggedIn = true;
        } else {
          this.onLoggedOut.next({});
          this.loggedIn = false;
          this.accessToken = null;

        }
      }

    }, false);
  }

  private _clientId: string;
  private _scopes: string[];
  private _redirect_uri: string;
  private _loggedIn: boolean;
  private _accessToken: AccessToken;
  private _profile : Profile;

  private _base: string;

  private _onLoggedIn: Subject<AccessToken> = new Subject();
  private _onLoggedOut: Subject<any> = new Subject();
  private _onProfileRecieved : Subject<Profile> = new Subject();

  private loginPath: string = "/acs2/iframe";
  private idpPath: string = "/idp/userinfo.openid";


  get clientId(): string {
    return this._clientId;
  }

  set clientId(value: string) {
    this._clientId = value;
  }

  get scopes(): string[] {
    return this._scopes;
  }

  set scopes(value: string[]) {
    this._scopes = value;
  }

  get redirect_uri(): string {
    return this._redirect_uri;
  }

  set redirect_uri(value: string) {
    this._redirect_uri = value;
  }


  get loggedIn(): boolean {
    return this._loggedIn;
  }

  set loggedIn(value: boolean) {
    this._loggedIn = value;
  }

  public signOn() {

    let iframe = this.getWindow(); // :( IFrames

    let msg = {
      "type": "login"
    };
    iframe.postMessage(JSON.stringify(msg), "*")


  }

  public signOut() {
    let iframe = this.getWindow(); // :( IFrames

    let msg = {
      "type": "logout"
    };

    iframe.postMessage(JSON.stringify(msg), "*");
  }

  private getWindow() {
    var element: any = document.getElementById("acs-api");
    return element.contentWindow;
  }


  get accessToken(): AccessToken {
    return this._accessToken;
  }

  set accessToken(value: AccessToken) {
    this._accessToken = value;
  }


  get onLoggedIn(): Subject<AccessToken> {
    return this._onLoggedIn;
  }

  get onLoggedOut(): Subject<any> {
    return this._onLoggedOut;
  }


  get onProfileRecieved(): Subject<Profile> {
    return this._onProfileRecieved;
  }

  get base(): string {
    return this._base;
  }

  set base(value: string) {
    this._base = value;
  }

  getServerUrl(): string {
    return `https://${this.base}.vspglobal.com${this.loginPath}`;
  }

  getIdUrl():string {
    return `https://${this.base}.vspglobal.com${this.idpPath}`;
  }

  get profile(): Profile{
    return this._profile
  }

  set profile(profile: Profile){
    this._profile = profile;
  }

  public getProfile() : void {
    let options = new RequestOptions();
    options.headers = new Headers();
    options.headers.set("Authorization", this.accessToken.toString());

    this.http.get(this.getIdUrl(),options).subscribe((resp) =>{
      let profile : Profile = resp.json();
      this.profile = profile;
      this.onProfileRecieved.next(profile);
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../src/lib/oauth.service.ts